"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLinksContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../assets/styles/config");
exports.StyledLinksContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.spaced ? 'space-between' : 'center'};
  margin-top: 15px;

  @media ${config_1.device.tablet} {
    flex-direction: row;
  }
  @media ${config_1.device.laptop} {
    flex-direction: column;
  }
  @media ${config_1.device.laptopLarge} {
    flex-direction: row;
  }
`;
